export const styles = {
    card: { 
        p: 3, 
        mb: 3, 
    }
}